const SET_NTH_CATEGORY = 'SET_NTH_CATEGORY';
const SET_NTH_CATEGORY_FULFILLMENT_OPTIONS = 'SET_NTH_CATEGORY_FULFILLMENT_OPTIONS';

export {
    SET_NTH_CATEGORY, SET_NTH_CATEGORY_FULFILLMENT_OPTIONS
};
